// For Development env use "Dev" 
//For Testing env use "Test"

const appMode = {
    env : 'Test',
    release : '1'
}

export const { env, release } = appMode;